import {Routes} from '@angular/router'
import {authGuard} from './1-application/auth.guard'
import {HOME_PATH, LOGIN_PATH, LOGOUT_PATH, QR_PATH} from './0-general/shared'

export const routes: Routes = [
  {
    path: LOGIN_PATH,
    loadComponent: () => import('./2-components/login/login.component').then(c => c.LoginComponent)
  },
  {
    path: LOGOUT_PATH,
    loadComponent: () => import('./2-components/logout/logout').then(c => c.Logout)
  },
  {
    path: HOME_PATH,
    loadChildren: () => import('./3-home/routes'),
    canActivate: [authGuard]
  },
  {
    // Just a Qr code for whatever reason
    path: QR_PATH,
    loadComponent: () => import('./2-components/qr/qr').then(m => m.Qr)
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: LOGIN_PATH
  },
  {
    path: '**',
    redirectTo: LOGIN_PATH
  }
]
